<template>
    <va-edit-layout>
        <CogCatalogItemTransaction-form
            :id="id"
            :title="title"
            :item="item"
        ></CogCatalogItemTransaction-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
